module.exports = __webpack_public_path__ + "static/media/winterdrive.bb0ebe39.jpg";